export const deepClone = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));



// WEBPACK FOOTER //
// ./src/app/_helpers/deepClone.ts